// extracted by mini-css-extract-plugin
module.exports = {"filtration":"styles_filtration__1_lp6","btn":"styles_btn__9OVIl","imageContainer":"styles_imageContainer__1Mltl"};